import React from 'react';
import { CircleLoader } from "react-spinners"; // Use named import

const Loader = () => {
    return (
        <div className="flex justify-center items-center py-8">
            <div className="relative">
                {/* Outer spinning circle */}
                <div className="w-12 h-12 rounded-full border-4 border-gray-200 border-t-blue-500 animate-spin"></div>

                {/* Inner spinning circle */}
                <div className="absolute top-1 left-1 w-10 h-10 rounded-full border-4 border-gray-100 border-t-blue-400 animate-spin"></div>
            </div>

            {/* CircleLoader spinner */}
            <span className="ml-3 text-gray-600 font-medium">
                <CircleLoader color="#3B82F6" size={50} />
            </span>
        </div>
    );
};

export default Loader;
